<template>
    <div class="uik-menuDrop">
        <transition name="uik-dropdown">
            <div v-if="state" :class="['uik-menuDrop__list', position !== '' ? 'uik-menuDrop__' + position:false]">
                <slot></slot>
            </div>
        </transition>
        <UikOverlay :visible="state" :opacity="5" @close="close" />
    </div>
</template>

<script>
export default {
    name: "UikDropdown",
    model: {
        prop: "state",
        event: "change"
    },
    props: {
        position: { type: String, default: "" },
        state: { type: Boolean, default: false }
    },
    methods: {
        close (event) {
            this.$emit("change", false)
        }
    }
}
</script>

<style lang="scss">
.uik-menuDrop {
    .uik-menuDrop__defaultDisplayComponent {
        width: 36px;
        padding: 0;
        text-align: center;
        justify-content: center;
        border-color: $borderColorDarker;
    }

    .uik-menuDrop__btnContent {
        justify-content: center;
    }

    .uik-menuDrop__list {
        position: absolute;
        z-index: 50;
        background: white;
        border: 1px solid $borderColorDarker;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        list-style: none;
        margin-top: 4px;
        min-width: 140px;
        top: auto;
        left: auto;
        right: auto;
        & > * {
            &:first-child {
                border-top-left-radius: 4px !important;
                border-top-right-radius: 4px !important;
            }
            &:last-child {
                border-bottom-left-radius: 4px !important;
                border-bottom-right-radius: 4px !important;
            }
        }
        &.uik-menuDrop__bottomLeft {
            top: 100%;
            left: 0;
            right: auto;
        }
        &.uik-menuDrop__topLeft,
        &.uik-menuDrop__topRight {
            left: 0;
            right: auto;
            top: 0;
            margin-top: 0;
            margin-bottom: 4px;
        }
        &.uik-menuDrop__topRight {
            top: 0;
            left: auto;
            right: 0;
        }
    }

    .uik-dropdown-item__wrapper,
    .uik-dropdown-item__wrapper:focus {
        border-left: none !important;
        border-top: none !important;
        border-right: none !important;
        border-radius: 0;
        font-size: 0.875rem;
        min-width: 100%;
        min-height: 38px;
        text-align: left;
        background: white;
        &:last-child {
            border-bottom: none !important;
        }
        &:hover {
            background: #f6f7f9;
        }
        & > * {
            justify-content: flex-start !important;
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.2s !important;
    }
}
</style>
